import React from "react";
import { motion } from "framer-motion";
import { FaCar, FaPhoneAlt, FaClock, FaTools, FaCheckCircle } from "react-icons/fa";
import "./MobileGarageInfo.css";

const MobileGarageInfo = () => {
  return (
    <section className="mobile-garage-section">
      <div className="mobile-garage-container">
        <motion.div 
          className="mobile-garage-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Your Trusted Mobile Garage Service</h2>
          <p className="section-subtitle">Professional automotive services delivered to your location</p>
        </motion.div>

        <div className="mobile-garage-content">
          <motion.div 
            className="info-main-card"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="info-icon-large">
              <FaCar />
            </div>
            <h3>We Come To You</h3>
            <p>
             No need to visit a garage or wait in line. Our fully equipped mobile service delivers professional automotive expertise directly to your doorstep. Whether you’re at home, at work, or stranded at the roadside, help is just one call away.
            </p>
            <div className="info-highlights">
              <div className="highlight-item">
                <FaCheckCircle />
                <span>Fully equipped mobile workshop</span>
              </div>
              <div className="highlight-item">
                <FaCheckCircle />
                <span>15+ years of experience</span>
              </div>
              <div className="highlight-item">
                <FaCheckCircle />
                <span>Family-run business</span>
              </div>
            </div>
          </motion.div>

          <div className="info-cards-grid">
            <motion.div 
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="info-card-icon">
                <FaPhoneAlt />
              </div>
              <h4>One Call Away</h4>
              <p>Quick response and booking. Just give us a call and we'll schedule your service at your convenience.</p>
              <a href="tel:+447501911970" className="info-link">
                Call: +447501911970
              </a>
            </motion.div>

            <motion.div 
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="info-card-icon emergency">
                <FaClock />
              </div>
              <h4>Emergency Service</h4>
              <p>24/7 emergency callout available. We understand breakdowns don't follow business hours.</p>
              <a href="tel:+447501911970" className="info-link emergency">
                Emergency Callout
              </a>
            </motion.div>

            {/* <motion.div 
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="info-card-icon">
                <FaMapMarkerAlt />
              </div>
              <h4>London & Essex</h4>
              <p>Serving all areas across London and Essex. Fast arrival times and reliable service coverage.</p>
              <a href="/contact" className="info-link">
                View Service Areas
              </a>
            </motion.div> */}

            <motion.div 
              className="info-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="info-card-icon">
                <FaTools />
              </div>
              <h4>Complete Services</h4>
              <p>From advanced diagnostics and repairs to ECU remapping and programming, we provide full garage capabilities on the move.</p>
              <a href="/contact" className="info-link">
                See All Services
              </a>
            </motion.div>
          </div>
        </div>

        <motion.div 
          className="cta-banner"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="cta-content">
            <h3>Need Mobile Garage Service Today?</h3>
            <p>Contact us now for immediate assistance or to book an appointment</p>
          </div>
          <div className="cta-buttons">
            <a href="tel:+447501911970" className="cta-btn primary">
              <FaPhoneAlt />
              Call Now
            </a>
            <a href="/contact" className="cta-btn secondary">
              Book Service
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MobileGarageInfo;
